import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export default function ReasearchDescripton({ documents, handleDownloadFile }) {
  const { t } = useTranslation();

  return (
    <>
      <h4>{t('projectProposal.researchDescription.viewLabel')}</h4>
      <h4>
        B1 - B5.{' '}
        {documents?.researchDescriptionFileUrl && (
          <span
            className="p-link text-primary underline font-normal"
            onClick={() => handleDownloadFile(documents?.researchDescriptionFileUrl)}
          >
            {t('projectProposal.researchDescription.attachment')}
          </span>
        )}
      </h4>
    </>
  );
}

ReasearchDescripton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  documents: PropTypes.object.isRequired,
  handleDownloadFile: PropTypes.func.isRequired,
};
